import { Sparkle } from "lucide-react";

const ITEMS = ["Corporate offices", "Professional offices", "Retail stores", "Showrooms", "Medical & dental facilities", "Multi-tenant properties", "Commercial facilities", "Peoria", "Glendale", "Surprise", "West Valley"];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((t) => (
      <span key={t} className="flex items-center">
        <span className="px-8 font-serif text-4xl italic text-ink md:text-6xl">{t}</span>
        <Sparkle className="h-5 w-5 text-emerald-600" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section aria-label="Sectors and service area" className="overflow-hidden border-y border-slate-200 bg-white py-8 md:py-10" data-testid="editorial-marquee">
    <div className="marquee-track flex w-max">
      <Row />
      <Row />
    </div>
  </section>
);
